module.exports = __webpack_public_path__ + "assets/demandbase.ab2b02f7.svg";